import { ComponentsState } from './types'

export default {
  components: [],
  loading: false
} as ComponentsState
